import mitt from 'mitt';
import type { Emitter } from 'mitt';

export default defineNuxtPlugin(nuxtApp => {
  const emitter: Emitter<Record<string, any>> = mitt<Record<string, any>>();
  
  nuxtApp.provide('emitter', emitter);
});

declare module '#app' {
  interface NuxtApp {
    $emitter: Record<string, any>;
  }
}